import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import DetailedPost from "../components/blogDescription/DetailedPost";
import GoHome from "../components/blogDescription/GoHome";
import RelatedPostList from "../components/blogDescription/relatedPost/RelatedPostList";
import { fetchSingleBlog } from "../features/blog/blogSlice";
import Loading from "../components/ui/Loading";

const Post = () => {
    const { blogId } = useParams();

    const dispatch = useDispatch();

    const { blog, isLoading, isError, error } = useSelector(
        (state) => state.blog
    );

    useEffect(() => {
        dispatch(fetchSingleBlog(blogId));
    }, [dispatch, blogId]);

    const { id, tags } = blog || {};

    // decide what to render
    let content = null;

    if (isLoading) content = <Loading />;

    if (!isLoading && isError)
        content = <div className="col-span-12">{error}</div>;

    if (!isLoading && !isError && !blog?.id) {
        content = <div className="col-span-12">No blog found!</div>;
    }

    if (!isLoading && !isError && blog?.id) {
        content = (
            <>
                <DetailedPost blog={blog} />
                <RelatedPostList currentBlogId={id} tags={tags} />
            </>
        );
    }

    return (
        <>
            <GoHome />

            <section className="post-page-container">{content}</section>
        </>
    );
};

export default Post;
